import { defineMessages } from 'react-intl';

export default defineMessages({
    quoteX: {
        id: 'ml.quoteandbind.pa.policySummary.Quote #',
        defaultMessage: 'Quote #: {quoteId}'
    },
    insured :  {
        id: 'ml.quoteandbind.pa.policySummary.Insured',
        defaultMessage: 'Insured'
    },
    coinsured :  {
        id: 'ml.quoteandbind.pa.policySummary.Co-Insured',
        defaultMessage: 'Co-Insured'
    },
    discounts : {
        id: 'ml.quoteandbind.pa.policySummary.discounts',
        defaultMessage: 'Discounts'

    },
    policyX: {
        id: 'ml.quoteandbind.pa.policySummary.Policy #',
        defaultMessage: 'Policy #{policyId}'
    },
    changeEffectiveDate: {
        id: 'ml.quoteandbind.pa.policySummary.Changes effective x',
        defaultMessage: 'Changes effective {date}'
    },
    changeConfirmationText: {
        id: 'ml.quoteandbind.pa.policySummary.Below are your changes. Confirm what is listed below is correct.',
        defaultMessage: 'Below are your changes. Confirm what is listed below is correct.'
    },
    insuranceSummaryText: {
        id: 'ml.quoteandbind.pa.policySummary.This summary of insurance coverage is issued as a matter of information only and confers no rights upon the holder. This summary does not amend, extend, or alter the coverage, terms, exclusions or conditions afforded by the policy referenced herein.',
        defaultMessage: 'This summary of insurance coverage is issued as a matter of information only and confers no rights upon the holder. This summary does not amend, extend, or alter the coverage, terms, exclusions or conditions afforded by the policy referenced herein.'
    },
    vieworeditText: {
        id: 'ml.quoteandbind.pa.policySummary.View/Edit Changes',
        defaultMessage: 'View/Edit Changes'
    }
});
